module.exports = __webpack_public_path__ + "assets/b49ff9626fdf4b81b7c4d823f15350e0.png";